// extracted by mini-css-extract-plugin
module.exports = {"order-dropdown":"_2jRTe","orderDropdown":"_2jRTe"};